var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 65 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9541 7.44541C12.9423 7.44541 14.5541 9.05719 14.5541 11.0454C14.5541 13.0336 12.9423 14.6454 10.9541 14.6454C8.96588 14.6454 7.3541 13.0336 7.3541 11.0454C7.3541 9.05719 8.96588 7.44541 10.9541 7.44541ZM10.9541 6.54541C13.4394 6.54541 15.4541 8.56013 15.4541 11.0454C15.4541 13.5307 13.4394 15.5454 10.9541 15.5454C8.46882 15.5454 6.4541 13.5307 6.4541 11.0454C6.4541 8.56013 8.46882 6.54541 10.9541 6.54541Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 66 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1.83333C16.0626 1.83333 20.1667 5.93739 20.1667 11C20.1667 16.0626 16.0626 20.1667 11 20.1667C5.93739 20.1667 1.83333 16.0626 1.83333 11C1.83333 5.93739 5.93739 1.83333 11 1.83333ZM11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 451",
    d: "M16.8145 3.80664L18.5594 5.45443L15.1265 9.0897L13.3816 7.44191L16.8145 3.80664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 452",
    d: "M3.04102 5.53857L4.78605 3.89089L8.21872 7.52638L6.47369 9.17406L3.04102 5.53857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 453",
    d: "M17.0322 18.2222L18.7772 16.5744L15.3443 12.9391L13.5993 14.5869L17.0322 18.2222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 454",
    d: "M3.04102 16.6975L4.78605 18.3452L8.21872 14.7097L6.47369 13.062L3.04102 16.6975Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterIcon);
export default __webpack_public_path__ + "static/media/help-center-icon.6928c54977d6dfe2f9a0d2fccabb5fee.svg";
export { ForwardRef as ReactComponent };